const Discord = () => {
    return (
        <div className="flex cursor-pointer">
            <a href="https://discordapp.com/users/932002006304948326" target={"_blank"} rel="noreferrer">
                <img src={'/logo-discord.svg'} alt="Discord"className="w-7" />
            </a>
        </div>
    )
}

export default Discord

